module.exports = __webpack_public_path__ + "static/media/art-show-award-2.811ad351.png";